const bannerOffice = "/assets/BANNER/Banner Office ACROE.png"
const bannerWorkshop = "/assets/BANNER/Banner Workshop ACROE.png"

const BigDrawerCabinet1Obj = "/assets/Drawer Cabinet/Big Drawer Cabinet - 1.obj";
const BigDrawerCabinet1Mtl = "/assets/Drawer Cabinet/Big Drawer Cabinet - 1.mtl";
const BigDrawerCabinet1Png = "/assets/Drawer Cabinet/Big Drawer Cabinet - 1.png";

const BigDrawerCabinet2Obj = "/assets/Drawer Cabinet/Big Drawer Cabinet - 2.obj";
const BigDrawerCabinet2Mtl = "/assets/Drawer Cabinet/Big Drawer Cabinet - 2.mtl";
const BigDrawerCabinet2Png = "/assets/Drawer Cabinet/Big Drawer Cabinet - 2.png";

const SmallDrawerCabinet1Obj = "/assets/Drawer Cabinet/Small Drawer Cabinet - 1.obj";
const SmallDrawerCabinet1Mtl = "/assets/Drawer Cabinet/Small Drawer Cabinet - 1.mtl";
const SmallDrawerCabinet1Png = "/assets/Drawer Cabinet/Small Drawer Cabinet - 1.png";

const SmallDrawerCabinet2Obj = "/assets/Drawer Cabinet/Small Drawer Cabinet - 2.obj";
const SmallDrawerCabinet2Mtl = "/assets/Drawer Cabinet/Small Drawer Cabinet - 2.mtl";
const SmallDrawerCabinet2Png = "/assets/Drawer Cabinet/Small Drawer Cabinet - 2.png";

const SmallDrawerCabinet3Obj = "/assets/Drawer Cabinet/Small Drawer Cabinet - 3.obj";
const SmallDrawerCabinet3Mtl = "/assets/Drawer Cabinet/Small Drawer Cabinet - 3.mtl";
const SmallDrawerCabinet3Png = "/assets/Drawer Cabinet/Small Drawer Cabinet - 3.png";

const SmallDrawerCabinet4Obj = "/assets/Drawer Cabinet/Small Drawer Cabinet - 4.obj";
const SmallDrawerCabinet4Mtl = "/assets/Drawer Cabinet/Small Drawer Cabinet - 4.mtl";
const SmallDrawerCabinet4Png = "/assets/Drawer Cabinet/Small Drawer Cabinet - 4.png";

const SmallDrawerCabinet5Obj = "/assets/Drawer Cabinet/Small Drawer Cabinet - 5.obj";
const SmallDrawerCabinet5Mtl = "/assets/Drawer Cabinet/Small Drawer Cabinet - 5.mtl";
const SmallDrawerCabinet5Png = "/assets/Drawer Cabinet/Small Drawer Cabinet - 5.png";

/* Filing Cabinet */
const FilingCabinet2LaciObj = "/assets/Filing Cabinet/Filing Cabinet 2 Laci.obj";
const FilingCabinet2LaciMtl = "/assets/Filing Cabinet/Filing Cabinet 2 Laci.mtl";
const FilingCabinet2LaciPng = "/assets/Filing Cabinet/Filing Cabinet 2 Laci.png";

const FilingCabinet3LaciObj = "/assets/Filing Cabinet/Filing Cabinet 3 Laci.obj";
const FilingCabinet3LaciMtl = "/assets/Filing Cabinet/Filing Cabinet 3 Laci.mtl";
const FilingCabinet3LaciPng = "/assets/Filing Cabinet/Filing Cabinet 3 Laci.png";

const FilingCabinet4LaciObj = "/assets/Filing Cabinet/Filing Cabinet 4 Laci.obj";
const FilingCabinet4LaciMtl = "/assets/Filing Cabinet/Filing Cabinet 4 Laci.mtl";
const FilingCabinet4LaciPng = "/assets/Filing Cabinet/Filing Cabinet 4 Laci.png";

const FilingCabinet4Laci2KunciObj = "/assets/Filing Cabinet/Filing Cabinet 4 Laci 2 Kunci.obj";
const FilingCabinet4Laci2KunciMtl = "/assets/Filing Cabinet/Filing Cabinet 4 Laci 2 Kunci.mtl";
const FilingCabinet4Laci2KunciPng = "/assets/Filing Cabinet/Filing Cabinet 4 Laci 2 Kunci.png";

const FilingCabinet4Laci4KunciObj = "/assets/Filing Cabinet/Filing Cabinet 4 Laci 4 Kunci.obj";
const FilingCabinet4Laci4KunciMtl = "/assets/Filing Cabinet/Filing Cabinet 4 Laci 4 Kunci.mtl";
const FilingCabinet4Laci4KunciPng = "/assets/Filing Cabinet/Filing Cabinet 4 Laci 4 Kunci.png";

/* Locker */
const LockerMultipleObj = "/assets/Locker/Locker Multiple.obj";
const LockerMultipleMtl = "/assets/Locker/Locker Multiple.mtl";
const LockerMultiplePng = "/assets/Locker/Locker Multiple.png";

const LockerSingle1Obj = "/assets/Locker/Locker Single - 1.obj";
const LockerSingle1Mtl = "/assets/Locker/Locker Single - 1.mtl";
const LockerSingle1Png = "/assets/Locker/Locker Single - 1.png";

const LockerSingle2Obj = "/assets/Locker/Locker Single - 2.obj";
const LockerSingle2Mtl = "/assets/Locker/Locker Single - 2.mtl";
const LockerSingle2Png = "/assets/Locker/Locker Single - 2.png";

/* Machine Tool Cabinet (MTC) */
const MTCS11001Obj = "/assets/Machine Tool Cabinet/MTC S 1100 - 1.obj";
const MTCS11001Mtl = "/assets/Machine Tool Cabinet/MTC S 1100 - 1.mtl";
const MTCS11001Png = "/assets/Machine Tool Cabinet/MTC S 1000 - 1.png";

const MTCS11002Obj = "/assets/Machine Tool Cabinet/MTC S 1100 - 2.obj";
const MTCS11002Mtl = "/assets/Machine Tool Cabinet/MTC S 1100 - 2.mtl";
const MTCS11002Png = "/assets/Machine Tool Cabinet/MTC S 1000 - 2.png";

const MTCS1100A1Obj = "/assets/Machine Tool Cabinet/MTC S 1100 A - 1.obj";
const MTCS1100A1Mtl = "/assets/Machine Tool Cabinet/MTC S 1100 A - 1.mtl";
const MTCS1100A1Png = "/assets/Machine Tool Cabinet/MTC S 1000 A - 1.png";

const MTCS1100A2Obj = "/assets/Machine Tool Cabinet/MTC S 1100 A - 2.obj";
const MTCS1100A2Mtl = "/assets/Machine Tool Cabinet/MTC S 1100 A - 2.mtl";
const MTCS1100A2Png = "/assets/Machine Tool Cabinet/MTC S 1000 A - 2.png";

const MTCS546FE1Obj = "/assets/Machine Tool Cabinet/MTC S 546 FE - 1.obj";
const MTCS546FE1Mtl = "/assets/Machine Tool Cabinet/MTC S 546 FE - 1.mtl";
const MTCS546FE1Png = "/assets/Machine Tool Cabinet/MTC S 546 FE - 1.png";

const MTCS546FE2Obj = "/assets/Machine Tool Cabinet/MTC S 546 FE - 2.obj";
const MTCS546FE2Mtl = "/assets/Machine Tool Cabinet/MTC S 546 FE - 2.mtl";
const MTCS546FE2Png = "/assets/Machine Tool Cabinet/MTC S 546 FE - 2.png";

const MTCS5501Obj = "/assets/Machine Tool Cabinet/MTC S 550 - 1.obj";
const MTCS5501Mtl = "/assets/Machine Tool Cabinet/MTC S 550 - 1.mtl";
const MTCS5501Png = "/assets/Machine Tool Cabinet/MTC S 550 - 1.png";

const MTCS5502Obj = "/assets/Machine Tool Cabinet/MTC S 550 - 2.obj";
const MTCS5502Mtl = "/assets/Machine Tool Cabinet/MTC S 550 - 2.mtl";
const MTCS5502Png = "/assets/Machine Tool Cabinet/MTC S 550 - 2.png";

const MTCS750FE1Obj = "/assets/Machine Tool Cabinet/MTC S 750 FE - 1.obj";
const MTCS750FE1Mtl = "/assets/Machine Tool Cabinet/MTC S 750 FE - 1.mtl";
const MTCS750FE1Png = "/assets/Machine Tool Cabinet/MTC S 750 FE - 1.png";

const MTCS750FE2Obj = "/assets/Machine Tool Cabinet/MTC S 750 FE - 2.obj";
const MTCS750FE2Mtl = "/assets/Machine Tool Cabinet/MTC S 750 FE - 2.mtl";
const MTCS750FE2Png = "/assets/Machine Tool Cabinet/MTC S 750 FE - 2.png";

const MTCS8001Obj = "/assets/Machine Tool Cabinet/MTC S 800 - 1.obj";
const MTCS8001Mtl = "/assets/Machine Tool Cabinet/MTC S 800 - 1.mtl";
const MTCS8001Png = "/assets/Machine Tool Cabinet/MTC S 800 - 1.png";

const MTCS8002Obj = "/assets/Machine Tool Cabinet/MTC S 800 - 2.obj";
const MTCS8002Mtl = "/assets/Machine Tool Cabinet/MTC S 800 - 2.mtl";
const MTCS8002Png = "/assets/Machine Tool Cabinet/MTC S 800 - 2.png";

const MTCS800A1Obj = "/assets/Machine Tool Cabinet/MTC S 800 A - 1.obj";
const MTCS800A1Mtl = "/assets/Machine Tool Cabinet/MTC S 800 A - 1.mtl";
const MTCS800A1Png = "/assets/Machine Tool Cabinet/MTC S 800 A - 1.png";

const MTCS800A2Obj = "/assets/Machine Tool Cabinet/MTC S 800 A - 2.obj";
const MTCS800A2Mtl = "/assets/Machine Tool Cabinet/MTC S 800 A - 2.mtl";
const MTCS800A2Png = "/assets/Machine Tool Cabinet/MTC S 800 A - 2.png";

/* Office Cabinet */
const BigBookshelfWithSlidingDoorObj = "/assets/Office Cabinet/Big Bookshelf with Sliding Door.obj";
const BigBookshelfWithSlidingDoorMtl = "/assets/Office Cabinet/Big Bookshelf with Sliding Door.mtl";
const BigBookshelfWithSlidingDoorPng = "/assets/Office Cabinet/Big Book Shelves with Sliding Door.png";

const BigOfficeCabinet1Obj = "/assets/Office Cabinet/Big Office Cabinet - 1.obj";
const BigOfficeCabinet1Mtl = "/assets/Office Cabinet/Big Office Cabinet - 1.mtl";
const BigOfficeCabinet1Png = "/assets/Office Cabinet/Big Office Cabinet - 1.png";

const BigOfficeCabinet2Obj = "/assets/Office Cabinet/Big Office Cabinet - 2.obj";
const BigOfficeCabinet2Mtl = "/assets/Office Cabinet/Big Office Cabinet - 2.mtl";
const BigOfficeCabinet2Png = "/assets/Office Cabinet/Big Office Cabinet - 2.png";

const OfficeCabinetOrdnerObj = "/assets/Office Cabinet/Office Cabinet Ordner.obj";
const OfficeCabinetOrdnerMtl = "/assets/Office Cabinet/Office Cabinet Ordner.mtl";
const OfficeCabinetOrdnerPng = "/assets/Office Cabinet/Office Cabinet Ordner.png";

const SmallOfficeCabinet1Obj = "/assets/Office Cabinet/Small Office Cabinet - 1.obj";
const SmallOfficeCabinet1Mtl = "/assets/Office Cabinet/Small Office Cabinet - 1.mtl";
const SmallOfficeCabinet1Png = "/assets/Office Cabinet/Small Office Cabinet - 1.png";

const SmallOfficeCabinet2Obj = "/assets/Office Cabinet/Small Office Cabinet - 2.obj";
const SmallOfficeCabinet2Mtl = "/assets/Office Cabinet/Small Office Cabinet - 2.mtl";
const SmallOfficeCabinet2Png = "/assets/Office Cabinet/Small Office Cabinet - 2.png";

/* Rack */
const RackCompartments1Obj = "/assets/Rack/Rack Compartments - 1.obj";
const RackCompartments1Mtl = "/assets/Rack/Rack Compartments - 1.mtl";
const RackCompartments1Png = "/assets/Rack/Rack Compartment - 1.png";

const RackCompartments2Obj = "/assets/Rack/Rack Compartments - 2.obj";
const RackCompartments2Mtl = "/assets/Rack/Rack Compartments - 2.mtl";
const RackCompartments2Png = "/assets/Rack/Rack Compartment - 2.png";

const RackOrdner1Obj = "/assets/Rack/Rack Ordner - 1.obj";
const RackOrdner1Mtl = "/assets/Rack/Rack Ordner - 1.mtl";
const RackOrdner1Png = "/assets/Rack/Rack Ordner - 1.png";

const RackOrdner2Obj = "/assets/Rack/Rack Ordner - 2.obj";
const RackOrdner2Mtl = "/assets/Rack/Rack Ordner - 2.mtl";
const RackOrdner2Png = "/assets/Rack/Rack Ordner - 2.png";

/* Tool Cupboard M92 */
const BigToolCupboardM921Obj = "/assets/Tool Cupboard/Big Tool Cupboard M92 - 1.obj";
const BigToolCupboardM921Mtl = "/assets/Tool Cupboard/Big Tool Cupboard M92 - 1.mtl";
const BigToolCupboardM921Png = "/assets/Tool Cupboard/Big Tool Cupboard M92 - 1.png";

const BigToolCupboardM922Obj = "/assets/Tool Cupboard/Big Tool Cupboard M92 - 2.obj";
const BigToolCupboardM922Mtl = "/assets/Tool Cupboard/Big Tool Cupboard M92 - 2.mtl";
const BigToolCupboardM922Png = "/assets/Tool Cupboard/Big Tool Cupboard M92 - 2.png";

const SmallToolCupboardM921Obj = "/assets/Tool Cupboard/Small Tool Cupboard M92 - 1.obj";
const SmallToolCupboardM921Mtl = "/assets/Tool Cupboard/Small Tool Cupboard M92 - 1.mtl";
const SmallToolCupboardM921Png = "/assets/Tool Cupboard/Small Tool Cupboard M92 - 1.png";

const SmallToolCupboardM922Obj = "/assets/Tool Cupboard/Small Tool Cupboard M92 - 2.obj";
const SmallToolCupboardM922Mtl = "/assets/Tool Cupboard/Small Tool Cupboard M92 - 2.mtl";
const SmallToolCupboardM922Png = "/assets/Tool Cupboard/Small Tool Cupboard M92 - 2.png";

/* Workbench */
const WorkbenchOnePedestalObj = "/assets/Workbench/Workbench One Pedestal.obj";
const WorkbenchOnePedestalMtl = "/assets/Workbench/Workbench One Pedestal.mtl";
const WorkbenchOnePedestalPng = "/assets/Workbench/Workbench One Pedestal.png";

const WorkbenchTypeEAObj = "/assets/Workbench/Workbench Type EA.obj";
const WorkbenchTypeEAMtl = "/assets/Workbench/Workbench Type EA.mtl";
const WorkbenchTypeEAPng = "/assets/Workbench/Workbench Type EA.png";

const WorkbenchTypeEBObj = "/assets/Workbench/Workbench Type EB.obj";
const WorkbenchTypeEBMtl = "/assets/Workbench/Workbench Type EB.mtl";
const WorkbenchTypeEBPng = "/assets/Workbench/Workbench Type EB.png";

const WorkbenchTypeECObj = "/assets/Workbench/Workbench Type EC.obj";
const WorkbenchTypeECMtl = "/assets/Workbench/Workbench Type EC.mtl";
const WorkbenchTypeECPng = "/assets/Workbench/Workbench Type EC.png";

const WorkbenchTypeEDObj = "/assets/Workbench/Workbench Type ED.obj";
const WorkbenchTypeEDMtl = "/assets/Workbench/Workbench Type ED.mtl";
const WorkbenchTypeEDPng = "/assets/Workbench/Workbench Type ED.png";

const WorkbenchWith2BlocksObj = "/assets/Workbench/Workbench with 2 Blocks.obj";
const WorkbenchWith2BlocksMtl = "/assets/Workbench/Workbench with 2 Blocks.mtl";
const WorkbenchWith2BlocksPng = "/assets/Workbench/Workbench with Two Blocks.png";

const WorkbenchWithOneBlock1Obj = "/assets/Workbench/Workbench with One Block - 1.obj";
const WorkbenchWithOneBlock1Mtl = "/assets/Workbench/Workbench with One Block - 1.mtl";
const WorkbenchWithOneBlock1Png = "/assets/Workbench/Workbench with One Block - 1.png";

const WorkbenchWithOneBlock2Obj = "/assets/Workbench/Workbench with One Block - 2.obj";
const WorkbenchWithOneBlock2Mtl = "/assets/Workbench/Workbench with One Block - 2.mtl";
const WorkbenchWithOneBlock2Png = "/assets/Workbench/Workbench with One Block - 2.png";


export const findProduct = (path, catalog = productCatalog) => {
  for (let i = 0; i < catalog.length; i++) {
    if (catalog[i].path === path) {
      return {
        product: catalog[i],
        others: catalog.filter((_, index) => index !== i)
      }
    }
    if (catalog[i].subCategories) {
      const found = findProduct(path, catalog[i].subCategories)
      if (found) {
        return found
      }
    }
  }
  return null
}

const productCatalog = [
  {
    label: "Office",
    image: bannerOffice,
    subCategories: [
      {
        label: "Filling Cabinet",
        subCategories: [
          {
            label: "Filing Cabinet 2 Drawers",
            description:
              "For ease of access and neatly arranged documents. Requires no assembly and fully welded for improved durability. It has 2 drawers with a central lock. Each drawers runs on 4 ball bearings for smooth opening and closing. Designed to accommodate hang maps of Folio size.",
            specification: {
              catalogNo: "100-200",
              finishing: "Powder Coating",
              note: "Available with wheels underneath",
              dimension: "W\t485\nD\t675\nH\t680\nW1\t380\nD1\t612\nH1\t282\n",
            },
            path: "/product/office/filingCabinet/2drawers",
            productModelScale: 0.12,
            productModel: [
              [FilingCabinet2LaciObj, FilingCabinet2LaciMtl, FilingCabinet2LaciPng],
            ],
          },
          {
            label: "Filing Cabinet 3 Drawers",
            description:
              "For ease of access and neatly arranged documents. Requires no assembly and fully welded for improved durability. It has 3 drawers with a central lock. Each drawers runs on 4 ball bearings for smooth opening and closing. Designed to accommodate hang maps of Folio size.",
            specification: {
              catalogNo: "100-300",
              finishing: "Powder Coating",
              note: "Available with wheels underneath",
              dimension: "W\t485\nD\t675\nH\t976\nW1\t380\nD1\t612\nH1\t282\n",
            },
            path: "/product/office/filingCabinet/3drawers",
            productModelScale: 0.12,
            productModel: [
              [FilingCabinet3LaciObj, FilingCabinet3LaciMtl, FilingCabinet3LaciPng],
            ],
          },
          {
            label: "Filing Cabinet 4 Drawers",
            description:
              "For ease of access and neatly arranged documents. Requires no assembly and fully welded for improved durability. It has 4 drawers with a central lock. Each drawers runs on 4 ball bearings for smooth opening and closing. Designed to accommodate hang maps of Folio size.",
            specification: {
              catalogNo: "100-400",
              finishing: "Powder Coating",
              note: "Available with wheels underneath",
              dimension: "W\t485\nD\t675\nH\t1272\nW1\t380\nD1\t612\nH1\t282\n",
            },
            path: "/product/office/filingCabinet/4drawers",
            productModelScale: 0.12,
            productModel: [
              [FilingCabinet4LaciObj, FilingCabinet4LaciMtl, FilingCabinet4LaciPng],
            ],
          },
          {
            label: "Filing Cabinet 4 Drawers with 2 Keys",
            description:
              "For ease of access and neatly arranged documents. Requires no assembly and fully welded for improved durability. It has 4 drawers with 2 locks for each of 2 drawers. Each drawers runs on 4 ball bearings for smooth opening and closing. Designed to accommodate hang maps of Folio size.",
            specification: {
              catalogNo: "100-420",
              finishing: "Powder Coating",
              note: "Available with wheels underneath",
              dimension: "W\t485\nD\t675\nH\t1272\nW1\t380\nD1\t612\nH1\t282\n",
            },
            path: "/product/office/filingCabinet/4drawers2keys",
            productModelScale: 0.12,
            productModel: [
              [
                FilingCabinet4Laci2KunciObj,
                FilingCabinet4Laci2KunciMtl,
                FilingCabinet4Laci2KunciPng,
              ],
            ],
          },
          {
            label: "Filing Cabinet 4 Drawers with 4 Keys",
            description:
              "For ease of access and neatly arranged documents. Requires no assembly and fully welded for improved durability. It has 4 drawers with 4 locks for each drawer. Each drawers runs on 4 ball bearings for smooth opening and closing. Designed to accommodate hang maps of Folio size.",
            specification: {
              catalogNo: "100-430",
              finishing: "Powder Coating",
              note: "Available with wheels underneath",
              dimension: "W\t485\nD\t675\nH\t1272\nW1\t380\nD1\t612\nH1\t282\n",
            },
            path: "/product/office/filingCabinet/4drawers4keys",
            productModelScale: 0.12,
            productModel: [
              [
                FilingCabinet4Laci4KunciObj,
                FilingCabinet4Laci4KunciMtl,
                FilingCabinet4Laci4KunciPng,
              ],
            ],
          },
        ],
      },

      {
        label: "Office Cabinet",
        subCategories: [
          {
            label: "Small Office Cabinet",
            description:
              "For ease of access and storage of supplies. Requires no assembly and fully welded for improved durability. It has 3 adjustable shelves with the posibility of adding extra shelf. It has 2 swing doors with hinges and a central lock. Versatile function for both Office and Workshop Equipments.",
            specification: {
              catalogNo: "402-100",
              finishing: "Powder Coating",
              note: "Available with 2 swing doors with glass",
              dimension: "W\t880\nD\t480\nH\t1825\nW1\t800\nD1\t-\nH1\t1718\n",
            },
            path: "/product/office/officeCabinet/smallOfficeCabinet",
            productModelScale: 0.02,
            productModel: [
              [SmallOfficeCabinet1Obj, SmallOfficeCabinet1Mtl, SmallOfficeCabinet1Png],
              [SmallOfficeCabinet2Obj, SmallOfficeCabinet2Mtl, SmallOfficeCabinet2Png],
            ],
          },
          {
            label: "Big Office Cabinet",
            description:
              "For ease of access and storage of even more supplies. Requires no assembly and fully welded for improved durability. It has 4 adjustable shelves with the posibility of adding extra shelf. It has 2 swing doors with hinges and a central lock. Versatile function for both Office and Workshop Equipments.",
            specification: {
              catalogNo: "402-200",
              finishing: "Powder Coating",
              note: "Available with 2 swing doors with glass",
              dimension: "W\t1180\nD\t600\nH\t2000\nW1\t1100\nD1\t-\nH1\t1870\n",
            },
            path: "/product/office/officeCabinet/bigOfficeCabinet",
            productModelScale: 0.02,
            productModel: [
              [BigOfficeCabinet1Obj, BigOfficeCabinet1Mtl, BigOfficeCabinet1Png],
              [BigOfficeCabinet2Obj, BigOfficeCabinet2Mtl, BigOfficeCabinet2Png],
            ],
          },
          {
            label: "Office Cabinet Ordner with Glass Door",
            description:
              "For ease of access and storage ordner folders. Requires no assembly and fully welded for improved durability. It has 3 adjustable shelves with the posibility of adding extra shelf. It has 2 swing doors with hinges and glass and a central lock. Specifically designed with the dimension of A4 ordner folders in mind.",
            specification: {
              catalogNo: "402-113K",
              finishing: "Powder Coating",
              note: "Available with 2 swing doors without glass",
              dimension: "W\t880\nD\t350\nH\t1825\nW1\t-\nD1\t-\nH1\t-\n",
            },
            path: "/product/office/officeCabinet/officeCabinetOrdnerWithGlassDoor",
            productModelScale: 0.08,
            productModel: [
              [OfficeCabinetOrdnerObj, OfficeCabinetOrdnerMtl, OfficeCabinetOrdnerPng],
            ],
          },
          {
            label: "Big Bookshelf with Sliding Door",
            description:
              "For safe keeping of books and documents. Requires no assembly and fully welded for improved durability. It is divided into 2 compartments with 2 independent sliding doors which run on sliding rollers. It has adjustable shelf and a lock for each compartment. Spacious and space-efficient.",
            specification: {
              catalogNo: "107-000",
              finishing: "Powder Coating",
              note: "",
              dimension: "W\t1050\nD\t515\nH\t2250\nW1\t-\nD1\t-\nH1\t350\n",
            },
            path: "/product/office/officeCabinet/bigBookshelfWithSlidingDoor",
            productModelScale: 0.08,
            productModel: [
              [BigBookshelfWithSlidingDoorObj, BigBookshelfWithSlidingDoorMtl, BigBookshelfWithSlidingDoorPng],
            ],
          },
          {
            label: "Big Bookshelf with Sliding Door",
            description:
              "For safe keeping of books and documents. Requires no assembly and fully welded for improved durability. It has a sliding doors which run on sliding rollers. It has 2 adjustable shelves and a central lock. Spacious and space-efficient.",
            specification: {
              catalogNo: "104-200",
              finishing: "Epoxy Polyester",
              note: "",
              dimension: "W\t1200\nD\t400\nH\t1090\nW1\t-\nD1\t-\nH1\t350\n",
            },
            path: "/product/office/officeCabinet/bigBookshelfWithSlidingDoor2",
            productModelScale: 0.08,
            productModel: [
              // No direct matching OBJs for the second bookshelf variant in tree; using the same bookshelf const as fallback
              [BigBookshelfWithSlidingDoorObj, BigBookshelfWithSlidingDoorMtl, BigBookshelfWithSlidingDoorPng],
            ],
          },
        ],
      },

      {
        label: "Locker",
        path: "/product/office/locker",
        subCategories: [
          {
            label: "Locker (Single)",
            description:
              "For storage of staff belongings, work attire, safety equipments and many more. Requires no assembly and fully welded for improved durability. Fully customisable according to the needs. It can be connected to other Lockers. Contact our representatives to get your own personalised locker!",
            specification: {
              catalogNo: "401-XXX",
              finishing: "Powder Coating",
              note:
                "Customisable according to demand with popular demand such as: \n- 1 Door \n- 2 Doors\n- 3 Doors\n- 4 Doors\n- 5 Doors\n- 6 Doors  Avaliable with or without supporting legs",
              dimension: "W\t380\nD\t380\nH\t2025\nW1\t-\nD1\t-\nH1\t-\n",
            },
            path: "/product/office/locker/lockerSingle",
            productModelScale: 0.08,
            productModel: [
              [LockerSingle1Obj, LockerSingle1Mtl, LockerSingle1Png],
              [LockerSingle2Obj, LockerSingle2Mtl, LockerSingle2Png],
            ],
          },
          {
            label: "Locker (Multiple)",
            description:
              "For storage of staff belongings, work attire, safety equipments and many more. Requires no assembly and fully welded for improved durability. Fully customisable according to the needs. Multiple columns in a unit. It can be connected to other Lockers. Contact our representatives to get your own personalised locker!",
            specification: {
              catalogNo: "400-XXX",
              finishing: "Powder Coating",
              note:
                "Customisable according to demand with popular demand such as:\n- 6 Door\n- 8 Doors\n- 12 Doors\n- 20 Doors  Avaliable with or without supporting legs",
              dimension: "W\t-\nD\t380\nH\t2025\nW1\t-\nD1\t-\nH1\t-\n",
            },
            path: "/product/office/locker/lockerMultiple",
            productModelScale: 1.4,
            productModel: [[LockerMultipleObj, LockerMultipleMtl, LockerMultiplePng]],
          },
        ],
      },

      {
        label: "Rack",
        subCategories: [
          {
            label: "Rack Ordner 4 Compartments",
            description:
              "For ease of access and storage ordner folders. Requires no assembly and fully welded for improved durability. It has 3 shelves and compatible with overhead divider. Specifically designed with the dimension of A4 ordner folders in mind.",
            specification: {
              catalogNo: "405-350",
              finishing: "Powder Coating",
              note: "",
              dimension: "W\t880\nD\t300\nH\t1500\nW1\t-\nD1\t-\nH1\t-\n",
            },
            path: "/product/office/rack/rackOrdner4",
            productModelScale: 0.004,
            productModel: [[RackOrdner1Obj, RackOrdner1Mtl, RackOrdner1Png]],
          },
          {
            label: "Rack Ordner 5 Compartments",
            description:
              "For ease of access and storage ordner folders. Requires no assembly and fully welded for improved durability. It has 4 shelves and compatible with overhead divider. Specifically designed with the dimension of A4 ordner folders in mind.",
            specification: {
              catalogNo: "405-380",
              finishing: "Powder Coating",
              note: "",
              dimension: "W\t880\nD\t300\nH\t1825\nW1\t-\nD1\t-\nH1\t-\n",
            },
            path: "/product/office/rack/rackOrdner5",
            productModelScale: 0.004,
            productModel: [[RackOrdner2Obj, RackOrdner2Mtl, RackOrdner2Png]],
          },
          {
            label: "Rack Compartment",
            description:
              "For ease of access and storage of materials, supplies, equipment and many more. Disassemblable for storage purspose when not needed and easier trasport. Fully customisable according to the needs. It can be connected to other Racks. Contact our representatives to get your own personalised racks!",
            specification: {
              catalogNo: "499-XXX",
              finishing: "Powder Coating",
              note:
                "Customisable according to demand with popular demand such as:\n- 3 Compartments\n- 4 Compartments\n- 5 Compartments\n- 6 Compartments",
              dimension: "W\t990\nD\t460\nH\t2125\nW1\t-\nD1\t-\nH1\t-\n",
            },
            path: "/product/office/rack/rackCompartment",
            productModelScale: 0.002,
            productModel: [
              [RackCompartments1Obj, RackCompartments1Mtl, RackCompartments1Png],
              [RackCompartments2Obj, RackCompartments2Mtl, RackCompartments2Png],
            ],
          },
        ],
      },

      // {
      //   label: "Mobile File",
      //   subCategories: [
      //     { label: "Mobile File Manual", path: "/product/office/mobileFile/manual" },
      //     { label: "Mobile File Mechanic", path: "/product/office/mobileFile/mechanic" },
      //     { label: "Mobile File Electric", path: "/product/office/mobileFile/electric" },
      //   ],
      // },
    ],
  },

  {
    label: "Workshop",
    image: bannerWorkshop,
    subCategories: [
      {
        label: "Drawer Cabinet",
        subCategories: [
          {
            label: "Small Drawer Cabinet",
            description:
              "Specifically designed for factory environment and storage of materials, supplies and equipment. Fully welded for improved durability with robust material. Each drawers runs on 4 ball bearings for smooth opening and closing. Highly customisable according to the need. Addition of partitions inside the drawer is recommended. Contact our representatives to get your own personalised cabinet!",
            specification: {
              catalogNo: "310-100",
              finishing: "Powder Coating",
              note:
                "Customisable according to demand with drawer heights such as: \n- 75 mm \n- 100 mm \n- 125 mm \n- 150 mm \n- 200 mm \n- 250 mm \n- 300 mm",
              dimension: "W\t717\nD\t707\nH\t1060\nW1\t-\nD1\t-\nH1\t-\n",
            },
            path: "/product/workshop/drawerCabinet/smallDrawerCabinet",
            productModelScale: 0.08,
            productModel: [
              [SmallDrawerCabinet1Obj, SmallDrawerCabinet1Mtl, SmallDrawerCabinet1Png],
              [SmallDrawerCabinet2Obj, SmallDrawerCabinet2Mtl, SmallDrawerCabinet2Png],
              [SmallDrawerCabinet3Obj, SmallDrawerCabinet3Mtl, SmallDrawerCabinet3Png],
              [SmallDrawerCabinet4Obj, SmallDrawerCabinet4Mtl, SmallDrawerCabinet4Png],
              [SmallDrawerCabinet5Obj, SmallDrawerCabinet5Mtl, SmallDrawerCabinet5Png],
            ],
          },
          {
            label: "Big Drawer Cabinet",
            description:
              "Specifically designed for factory environment and storage of materials, supplies and equipment. Fully welded for improved durability with robust material. Each drawers runs on 4 ball bearings for smooth opening and closing. Highly customisable according to the need. Addition of partitions inside the drawer is recommended. Contact our representatives to get your own personalised cabinet!",
            specification: {
              catalogNo: "310-200",
              finishing: "Powder Coating",
              note:
                "Customisable according to demand with drawer heights such as: \n- 75 mm \n- 100 mm \n- 125 mm \n- 150 mm \n- 200 mm \n- 250 mm \n- 300 mm",
              dimension: "W\t1193\nD\t707\nH\t1060\nW1\t-\nD1\t-\nH1\t-\n",
            },
            path: "/product/workshop/drawerCabinet/bigDrawerCabinet",
            productModelScale: 0.08,
            productModel: [
              [BigDrawerCabinet1Obj, BigDrawerCabinet1Mtl, BigDrawerCabinet1Png],
              [BigDrawerCabinet2Obj, BigDrawerCabinet2Mtl, BigDrawerCabinet2Png],
            ],
          },
          // {
          //   label: "Drawer Cabinet B33",
          //   description:
          //     "Specifically designed for factory environment and storage of materials, supplies and equipment. Fully welded for improved durability with robust material. Each drawers runs on 4 ball bearings for smooth opening and closing. Highly customisable according to the need. Addition of partitions inside the drawer is recommended. Contact our representatives to get your own personalised cabinet!",
          //   specification: {
          //     catalogNo: "310-200",
          //     finishing: "Powder Coating",
          //     note:
          //       "Customisable according to demand with drawer heights such as:\n- 75 mm\n- 100 mm\n- 125 mm\n- 150 mm\n- 200 mm\n- 250 mm\n- 300 mm",
          //     dimension: "W\t1193\nD\t707\nH\t1060\nW1\t-\nD1\t-\nH1\t-\n",
          //   },
          //   path: "/product/workshop/drawerCabinet/drawerCabinetB33",
          //   // no matching OBJ/MTL/PNG found in tree for Drawer Cabinet B33
          //   productModelScale: 0.02,
          //   productModel: [],
          // },
        ],
      },

      {
        label: "Machine Tool Cabinet",
        subCategories: [
          {
            label: "Machine Tool Cabinet S550",
            description:
              "Specifically designed for factory environment and storage of equipments, tools and machinery. Fully welded for improved durability with robust material. One top drawer. Top of cabinet covered with rubber. Load Capacity up to 100 kg. Single swing door with lock.",
            specification: {
              catalogNo: "301-000",
              finishing: "Powder Coating",
              note: "",
              dimension: "W\t500\nD\t560\nH\t1000\nW1\t-\nD1\t-\nH1\t-\n",
            },
            path: "/product/workshop/machineToolCabinet/S550",
            productModelScale: 0.08,
            productModel: [
              [MTCS5501Obj, MTCS5501Mtl, MTCS5501Png],
              [MTCS5502Obj, MTCS5502Mtl, MTCS5502Png],
            ],
          },
          {
            label: "Machine Tool Cabinet S800",
            description:
              "Specifically designed for factory environment and storage of equipments, tools and machinery. Fully welded for improved durability with robust material. One Top drawer. Top of cabinet covered with rubber. Load Capacity up to 100 kg. Two swing doors with lock.",
            specification: {
              catalogNo: "302-000",
              finishing: "Powder Coating",
              note: "",
              dimension: "W\t800\nD\t560\nH\t1000\nW1\t-\nD1\t-\nH1\t-\n",
            },
            path: "/product/workshop/machineToolCabinet/S800",
            productModelScale: 0.08,
            productModel: [
              [MTCS8001Obj, MTCS8001Mtl, MTCS8001Png],
              [MTCS8002Obj, MTCS8002Mtl, MTCS8002Png],
            ],
          },
          {
            label: "Machine Tool Cabinet S800 A",
            description:
              "Specifically designed for factory environment and storage of equipments, tools and machinery. Fully welded for improved durability with robust material. One Top drawer and one 100% extendable pull-out shelf at the bottom. Top of cabinet covered with rubber. Load Capacity up to 100 kg. Two swing doors with lock.",
            specification: {
              catalogNo: "302-100",
              finishing: "Powder Coating",
              note: "",
              dimension: "W\t800\nD\t560\nH\t1000\nW1\t-\nD1\t-\nH1\t-\n",
            },
            path: "/product/workshop/machineToolCabinet/S800A",
            productModelScale: 0.08,
            productModel: [
              [MTCS800A1Obj, MTCS800A1Mtl, MTCS800A1Png],
              [MTCS800A2Obj, MTCS800A2Mtl, MTCS800A2Png],
            ],
          },
          {
            label: "Machine Tool Cabinet S1100",
            description:
              "Specifically designed for factory environment and storage of equipments, tools and machinery. Fully welded for improved durability with robust material. One Top drawer. Top of cabinet covered with rubber. Load Capacity up to 100 kg. Two swing doors with lock.",
            specification: {
              catalogNo: "303-000",
              finishing: "Powder Coating",
              note: "",
              dimension: "W\t1100\nD\t560\nH\t1000\nW1\t-\nD1\t-\nH1\t-\n",
            },
            path: "/product/workshop/machineToolCabinet/S1100",
            productModelScale: 0.08,
            productModel: [
              [MTCS11001Obj, MTCS11001Mtl, MTCS11001Png],
              [MTCS11002Obj, MTCS11002Mtl, MTCS11002Png],
            ],
          },
          {
            label: "Machine Tool Cabinet S1100 A",
            description:
              "Specifically designed for factory environment and storage of equipments, tools and machinery. Fully welded for improved durability with robust material. One Top drawer and one 100% extendable pull-out shelf at the bottom. Top of cabinet covered with rubber. Load Capacity up to 100 kg. Two swing doors with lock.",
            specification: {
              catalogNo: "303-100",
              finishing: "Powder Coating",
              note: "",
              dimension: "W\t1100\nD\t560\nH\t1000\nW1\t-\nD1\t-\nH1\t-\n",
            },
            path: "/product/workshop/machineToolCabinet/S1100A",
            productModelScale: 0.08,
            productModel: [
              [MTCS1100A1Obj, MTCS1100A1Mtl, MTCS1100A1Png],
              [MTCS1100A2Obj, MTCS1100A2Mtl, MTCS1100A2Png],
            ],
          },
          {
            label: "Machine Tool Cabinet S546 FE",
            description:
              "Specifically designed for factory environment and storage of equipments, tools and machinery. Fully welded for improved durability with robust material. Three extention drawers supported by 8 ball bearings and two 100% extendable pull-out shelves below. Top of cabinet covered with rubber. Load Capacity up to 100 kg. Two swing doors with lock.",
            specification: {
              catalogNo: "304-000",
              finishing: "Powder Coating",
              note: "",
              dimension: "W\t1100\nD\t560\nH\t1000\nW1\t-\nD1\t-\nH1\t-\n",
            },
            path: "/product/workshop/machineToolCabinet/S546FE",
            productModelScale: 0.08,
            productModel: [
              [MTCS546FE1Obj, MTCS546FE1Mtl, MTCS546FE1Png],
              [MTCS546FE2Obj, MTCS546FE2Mtl, MTCS546FE2Png],
            ],
          },
          {
            label: "Machine Tool Cabinet S750 FE",
            description:
              "Specifically designed for factory environment and storage of equipments, tools and machinery. Fully welded for improved durability with robust material. Three extention drawers supported by 8 ball bearings and two 100% extendable pull-out shelves below. Top of cabinet covered with rubber. Load Capacity up to 100 kg. Two swing doors with lock.",
            specification: {
              catalogNo: "305-000",
              finishing: "Powder Coating",
              note: "",
              dimension: "W\t1100\nD\t560\nH\t1000\nW1\t-\nD1\t-\nH1\t-\n",
            },
            path: "/product/workshop/machineToolCabinet/S750FE",
            productModelScale: 0.08,
            productModel: [
              [MTCS750FE1Obj, MTCS750FE1Mtl, MTCS750FE1Png],
              [MTCS750FE2Obj, MTCS750FE2Mtl, MTCS750FE2Png],
            ],
          },
          // {
          //   label: "Machine Tool Cabinet MTC-85",
          //   description:
          //     "Specifically designed for factory environment and storage of equipments, tools and machinery. Fully welded for improved durability with robust material. Five extention drawers supported by 8 ball bearings and two 100% extendable pull-out shelves below. Top of cabinet covered with rubber. Load Capacity up to 100 kg. One swing doors with lock.",
          //   specification: {
          //     catalogNo: "301-085",
          //     finishing: "Powder Coating",
          //     note: "",
          //     dimension: "W\t717\nD\t725\nH\t1450\nW1\t-\nD1\t-\nH1\t-\n",
          //   },
          //   path: "/product/workshop/machineToolCabinet/MTC85",
          //   // no matching OBJ/MTL/PNG found for MTC-85 in tree → leave empty
          //   productModelScale: 0.02,
          //   productModel: [],
          // },
        ],
      },

      {
        label: "Workbench",
        subCategories: [
          {
            label: "Workbench with One Drawer Block",
            description:
              "Specifically designed for working in factory and industrial environment and withstanding heavy machinery. Fully welded for improved durability with robust material. Top table from pure 50 mm teak wood (Jati) with protective coating. One Drawer Block below the table. Load Capacity up to 300 kg.",
            specification: {
              catalogNo: "336-100",
              finishing: "Powder Coating",
              note: "Drawer Block placement can be on the right or left according to preference",
              dimension: "W\t2000\nD\t800\nH\t850\nW1\t-\nD1\t-\nH1\t-",
            },
            path: "/product/workshop/workbench/OneDrawerBlock",
            productModelScale: 0.003,
            productModel: [
              [WorkbenchWithOneBlock1Obj, WorkbenchWithOneBlock1Mtl, WorkbenchWithOneBlock1Png],
              [WorkbenchWithOneBlock2Obj, WorkbenchWithOneBlock2Mtl, WorkbenchWithOneBlock2Png],
            ],
          },
          {
            label: "Workbench with Two Drawer Block",
            description:
              "Specifically designed for working in factory and industrial environment and withstanding heavy machinery. Fully welded for improved durability with robust material. Top table from pure 50 mm teak wood (Jati) with protective coating. Two Drawer Blocks below the table. Load Capacity up to 300 kg.",
            specification: {
              catalogNo: "336-200",
              finishing: "Powder Coating",
              note: "Drawer Block placement can be on the right or left according to preference",
              dimension: "W\t2500\nD\t800\nH\t850\nW1\t-\nD1\t-\nH1\t-",
            },
            path: "/product/workshop/workbench/TwoDrawerBlock",
            productModelScale: 0.6,
            productModel: [
              [WorkbenchWith2BlocksObj, WorkbenchWith2BlocksMtl, WorkbenchWith2BlocksPng],
            ],
          },
          {
            label: "Workbench with One Pedestal",
            description:
              "Specifically designed for working in factory and industrial environment and withstanding heavy machinery. Fully welded for improved durability with robust material. Top table from pure 50 mm teak wood (Jati) with protective coating. One Drawer Cabinet on the side. Load Capacity up to 300 kg.",
            specification: {
              catalogNo: "337-100",
              finishing: "Powder Coating",
              note: "Drawer Cabinet placement can be on the right or left according to preference",
              dimension: "W\t2000\nD\t800\nH\t850\nW1\t-\nD1\t-\nH1\t-",
            },
            path: "/product/workshop/workbench/OnePedestal",
            productModelScale: 0.6,
            productModel: [
              [WorkbenchOnePedestalObj, WorkbenchOnePedestalMtl, WorkbenchOnePedestalPng],
            ],
          },
          {
            label: "Workbench Type EA",
            description:
              "Specifically designed for working in factory and industrial environment and withstanding heavy machinery. Fully welded for improved durability with robust material. Top table from 25 mm multiplex with formica coating. 3 top electrical sockets and 3 side electrical sockets.",
            specification: {
              catalogNo: "338-010",
              finishing: "Powder Coating",
              note: "Electrical Socket placement can be on the right or left according to preference",
              dimension: "W\t2000\nD\t800\nH\t850\nW1\t-\nD1\t-\nH1\t-",
            },
            path: "/product/workshop/workbench/TypeEA",
            productModelScale: 0.002,
            productModel: [[WorkbenchTypeEAObj, WorkbenchTypeEAMtl, WorkbenchTypeEAPng]],
          },
          {
            label: "Workbench Type EB",
            description:
              "Specifically designed for working in factory and industrial environment and withstanding heavy machinery. Fully welded for improved durability with robust material. Top table from 25 mm multiplex with formica coating. 3 top electrical sockets and 3 side electrical sockets. One Drawer Cabinet on the side.",
            specification: {
              catalogNo: "338-020",
              finishing: "Powder Coating",
              note: "Drawer Cabinet and Electrical Socket placement can be on the right or left according to preference",
              dimension: "W\t2000\nD\t800\nH\t850\nW1\t-\nD1\t-\nH1\t-",
            },
            path: "/product/workshop/workbench/TypeEB",
            productModelScale: 0.6,
            productModel: [[WorkbenchTypeEBObj, WorkbenchTypeEBMtl, WorkbenchTypeEBPng]],
          },
          {
            label: "Workbench Type EC",
            description:
              "Specifically designed for working in factory and industrial environment and withstanding heavy machinery. Fully welded for improved durability with robust material. Top table from 25 mm multiplex with formica coating. 3 top electrical sockets and 3 side electrical sockets. Two smaller Drawer Cabinets on the side.",
            specification: {
              catalogNo: "338-030",
              finishing: "Powder Coating",
              note: "Drawer Cabinet and Electrical Socket placement can be on the right or left according to preference",
              dimension: "W\t2000\nD\t800\nH\t850\nW1\t-\nD1\t-\nH1\t-",
            },
            path: "/product/workshop/workbench/TypeEC",
            productModelScale: 0.002,
            productModel: [[WorkbenchTypeECObj, WorkbenchTypeECMtl, WorkbenchTypeECPng]],
          },
          {
            label: "Workbench Type ED",
            description:
              "Specifically designed for working in factory and industrial environment and withstanding heavy machinery. Fully welded for improved durability with robust material. Top table from 25 mm multiplex with formica coating. 3 top electrical sockets and 3 side electrical sockets. One Drawer Block below the table.",
            specification: {
              catalogNo: "338-040",
              finishing: "Powder Coating",
              note: "Drawer Block and Electrical Socket placement can be on the right or left according to preference",
              dimension: "W\t2000\nD\t800\nH\t850\nW1\t-\nD1\t-\nH1\t-",
            },
            path: "/product/workshop/workbench/TypeED",
            productModelScale: 0.6,
            productModel: [[WorkbenchTypeEDObj, WorkbenchTypeEDMtl, WorkbenchTypeEDPng]],
          },
        ],
      },

      {
        label: "Tool Cupboard",
        subCategories: [
          {
            label: "Small Tool Cupboard",
            description:
              "For ease of access and storage of supplies. Requires no assembly and fully welded for improved durability. It has 3 adjustable shelves with the posibility of adding extra shelf. It has 2 swing doors with hinges and a central lock. Versatile function for both Office and Workshop Equipments.",
            specification: {
              catalogNo: "402-100W",
              finishing: "Powder Coating",
              note: "Available with 2 swing doors with glass",
              dimension: "W\t880\nD\t480\nH\t1825\nW1\t800\nD1\t-\nH1\t1718",
            },
            path: "/product/workshop/toolCupboard/smallToolCupboard",
            productModelScale: 0.02,
            productModel: [
              [SmallOfficeCabinet1Obj, SmallOfficeCabinet1Mtl, SmallOfficeCabinet1Png],
              [SmallOfficeCabinet2Obj, SmallOfficeCabinet2Mtl, SmallOfficeCabinet2Png],
            ],
          },
          {
            label: "Big Tool Cupboard",
            description:
              "For ease of access and storage of even more supplies. Requires no assembly and fully welded for improved durability. It has 4 adjustable shelves with the posibility of adding extra shelf. It has 2 swing doors with hinges and a central lock. Versatile function for both Office and Workshop Equipments.",
            specification: {
              catalogNo: "402-200W",
              finishing: "Powder Coating",
              note: "Available with 2 swing doors with glass",
              dimension: "W\t1180\nD\t600\nH\t2000\nW1\t1100\nD1\t-\nH1\t1870",
            },
            path: "/product/workshop/toolCupboard/bigToolCupboard",
            productModelScale: 0.02,
            productModel: [
              [BigOfficeCabinet1Obj, BigOfficeCabinet1Mtl, BigOfficeCabinet1Png],
              [BigOfficeCabinet2Obj, BigOfficeCabinet2Mtl, BigOfficeCabinet2Png],
            ],
          },
          {
            label: "Small Tool Cupboard M92",
            description:
              "For ease of access and storage of tools. Requires no assembly and fully welded for improved durability. It has 3 adjustable shelves with sockets especially for BT Tool Holder. It has 2 swing doors with hinges and a central lock.",
            specification: {
              catalogNo: "402-192",
              finishing: "Powder Coating",
              note: "Tool Holder avaliable in size BT 30, BT 40 and BT 50",
              dimension: "W\t880\nD\t480\nH\t1825\nW1\t800\nD1\t-\nH1\t1718",
            },
            path: "/product/workshop/toolCupboard/smallToolCupboardM92",
            productModelScale: 0.06,
            productModel: [
              [SmallToolCupboardM921Obj, SmallToolCupboardM921Mtl, SmallToolCupboardM921Png],
              [SmallToolCupboardM922Obj, SmallToolCupboardM922Mtl, SmallToolCupboardM922Png],
            ],
          },
          {
            label: "Big Tool Cupboard M92",
            description:
              "For ease of access and storage of tools. Requires no assembly and fully welded for improved durability. It has 4 adjustable shelves with sockets especially for BT Tool Holder with the posibility of adding extra shelf. It has 2 swing doors with hinges and a central lock.",
            specification: {
              catalogNo: "402-292",
              finishing: "Powder Coating",
              note: "Tool Holder avaliable in size BT 30, BT 40 and BT 50",
              dimension: "W\t1180\nD\t600\nH\t2000\nW1\t1100\nD1\t-\nH1\t1870",
            },
            path: "/product/workshop/toolCupboard/bigToolCupboardM92",
            productModelScale: 0.06,
            productModel: [
              [BigToolCupboardM921Obj, BigToolCupboardM921Mtl, BigToolCupboardM921Png],
              [BigToolCupboardM922Obj, BigToolCupboardM922Mtl, BigToolCupboardM922Png],
            ],
          },
        ],
      },
    ],
  },
];

export default productCatalog